(function () {
  try {
    // ============================
    // CONFIG
    // ============================
    var DEFAULT_COLLECTION_HANDLE = 'all-chocolate';
    var DEFAULT_COLLECTION_TITLE = 'All Chocolate';
    var WINDOW_MS = 15000;

    // ----------------------------
    // Helpers
    // ----------------------------
    function bodyHas(prefix) {
      // substring match (works with template-collection--handle etc)
      return (document.body && document.body.className || '').indexOf(prefix) !== -1;
    }

    function getCollectionHandleFromPath() {
      // /collections/handle or /collections/handle/products/...
      var p = window.location.pathname || '';
      var m = p.match(/\/collections\/([^\/\?\#]+)/);
      return (m && m[1]) ? m[1] : '';
    }

    function makeSep() {
      var sep = document.createElement('span');
      sep.className = 'breadcrumb__sep';
      sep.setAttribute('aria-hidden', 'true');
      sep.style.margin = '0 8px';
      sep.style.opacity = '.6';
      sep.textContent = '›';
      return sep;
    }

    function makeCollectionLink(handle, title) {
      var a = document.createElement('a');
      a.className = 'breadcrumb__link';
      a.href = '/collections/' + handle;
      a.textContent = title;
      return a;
    }

    function wipeAfterHome(nav) {
      var homeLink = nav.querySelector('a.breadcrumb__link');
      if (!homeLink) return null;
      var node = homeLink.nextSibling;
      while (node) {
        var next = node.nextSibling;
        node.parentNode.removeChild(node);
        node = next;
      }
      return homeLink;
    }

    function getClickedHref(e) {
      var a = e.target.closest && e.target.closest('a');
      var href = '';
      if (a) href = a.getAttribute('href') || '';
      if (!href && e.target.closest) {
        var el = e.target.closest('[href],[data-url],[data-href]');
        if (el) href = el.getAttribute('href') || el.getAttribute('data-url') || el.getAttribute('data-href') || '';
      }
      return href;
    }

    // ============================
    // COLLECTION PAGE: store + flag ONLY on product click
    // ============================
    if (bodyHas('template-collection')) {
      // handle from URL is most reliable
      var handle = getCollectionHandleFromPath();

      // title from hidden div if present (nice-to-have)
      var title = '';
      var meta = document.querySelector('[data-sd-collection]');
      if (meta) {
        title = meta.getAttribute('data-sd-collection-title') || '';
        // If you also set handle in the hook, prefer it
        var hookHandle = meta.getAttribute('data-sd-collection-handle') || '';
        if (hookHandle) handle = hookHandle;
      }

      // If we couldn't get a title, use handle as fallback (still better than nothing)
      if (!title && handle) title = handle.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });

      if (!handle) return;

      document.addEventListener('click', function (e) {
        var href = getClickedHref(e);
        if (!href || href.indexOf('/products/') === -1) return;

        try {
          localStorage.setItem('sd_last_collection_handle', handle);
          localStorage.setItem('sd_last_collection_title', title);

          sessionStorage.setItem('sd_from_collection', '1');
          sessionStorage.setItem('sd_from_collection_ts', String(Date.now()));
        } catch (err) {}
      }, true);

      return;
    }

    // ============================
    // HOME PAGE: set "from home" ONLY on product click
    // ============================
    if (bodyHas('template-index')) {
      document.addEventListener('click', function (e) {
        var href = getClickedHref(e);
        if (!href || href.indexOf('/products/') === -1) return;

        try {
          sessionStorage.setItem('sd_from_home', '1');
          sessionStorage.setItem('sd_from_home_ts', String(Date.now()));
        } catch (err) {}
      }, true);

      return;
    }

    // ============================
    // PRODUCT PAGE: Home › (collection if from collection click else All Chocolate)
    // ============================
    if (!bodyHas('template-product')) return;

    var nav = document.getElementById('sd-breadcrumb');
    if (!nav) return;

    var useHandle = '';
    var useTitle = '';

    // A) Prefer the "from collection click" flag
    var fromCollection = sessionStorage.getItem('sd_from_collection');
    var fromCollectionTs = parseInt(sessionStorage.getItem('sd_from_collection_ts') || '0', 10);

    if (fromCollection === '1' && fromCollectionTs && (Date.now() - fromCollectionTs) <= WINDOW_MS) {
      useHandle = localStorage.getItem('sd_last_collection_handle') || '';
      useTitle  = localStorage.getItem('sd_last_collection_title') || '';
    }

    // Clear so it never sticks
    try {
      sessionStorage.removeItem('sd_from_collection');
      sessionStorage.removeItem('sd_from_collection_ts');
      sessionStorage.removeItem('sd_from_home');
      sessionStorage.removeItem('sd_from_home_ts');
    } catch (e) {}

    // B) If not from a collection click, ALWAYS fall back to All Chocolate
    if (!useHandle || !useTitle) {
      useHandle = DEFAULT_COLLECTION_HANDLE;
      useTitle  = DEFAULT_COLLECTION_TITLE;
    }

    // Build breadcrumb: Home › Collection (NO product name)
    var homeLink = wipeAfterHome(nav);
    if (!homeLink) return;

    homeLink.after(makeSep(), makeCollectionLink(useHandle, useTitle));
  } catch (e) {}
})();
